var map = {
	"./accurate_pos.png": "a66d",
	"./blibli_id.png": "29f3b",
	"./lazada_id.png": "2fa9",
	"./shopee_id.png": "490b",
	"./switch-horizontal.png": "8979",
	"./tiktok-shop.png": "8370",
	"./tiktok.png": "f858",
	"./tiktok_id.png": "232e",
	"./tiktok_tokopedia.png": "11b2",
	"./toco_id.png": "fda8",
	"./tokopedia.png": "fe23",
	"./tokopedia_id.png": "14cd",
	"./zalora_id.png": "2099"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de79";